
































import { get } from 'lodash';
import CoAlert from '@/components/Molecules/co-alert/CoAlert.vue';

export default {
    name: 'SignupSuspendedView',
    components: {
        CoAlert,
    },
    methods: {
        get,
    },
};
